export function OpponentScouting() {
  return (
    <div className="space-y-10">

      {/* PAGE HEADER */}
      <div>
        <h1 className="text-3xl font-bold mb-2">Opponent Scouting</h1>
        <p className="text-muted">
          External intelligence for analyzing teams you may face this season.
        </p>
      </div>

      {/* SEARCH + FILTER BAR */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        
        {/* Search */}
        <input
          type="text"
          placeholder="Search teams..."
          className="
            w-full md:w-80 bg-surface border border-border rounded-md p-3
            focus:outline-none focus:border-[#4FC3F7]
          "
        />

        {/* Filters */}
        <div className="flex gap-3">
          <select
            className="
              bg-surface border border-border rounded-md p-2
              focus:outline-none focus:border-[#4FC3F7]
            "
          >
            <option>All Divisions</option>
            <option>Advanced</option>
            <option>Main</option>
            <option>Intermediate</option>
            <option>Open</option>
          </select>

          <select
            className="
              bg-surface border border-border rounded-md p-2
              focus:outline-none focus:border-[#4FC3F7]
            "
          >
            <option>Sort by</option>
            <option>ELO (High → Low)</option>
            <option>ELO (Low → High)</option>
            <option>Recent Form</option>
            <option>Win Rate</option>
          </select>
        </div>
      </div>

      {/* TEAM GRID */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">

        {/* TEAM CARD */}
        <div className="bg-surface border border-border rounded-lg p-5 hover:border-[#4FC3F7] transition">
          
          {/* Team Header */}
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-full bg-[#1F242C]" />
            <div>
              <p className="font-semibold">Team Name</p>
              <p className="text-xs text-muted">Advanced Division</p>
            </div>
          </div>

          {/* ELO */}
          <p className="text-sm mb-3">
            <span className="text-muted">Avg ELO:</span>{" "}
            <span className="font-semibold text-[#4FC3F7]">2450</span>
          </p>

          {/* Roster Preview */}
          <div className="space-y-2 mb-4">
            <p className="text-xs text-muted uppercase">Roster</p>

            <div className="flex items-center gap-2">
              <div className="w-6 h-6 rounded-full bg-[#1F242C]" />
              <p className="text-sm">Player1</p>
            </div>

            <div className="flex items-center gap-2">
              <div className="w-6 h-6 rounded-full bg-[#1F242C]" />
              <p className="text-sm">Player2</p>
            </div>

            <div className="flex items-center gap-2">
              <div className="w-6 h-6 rounded-full bg-[#1F242C]" />
              <p className="text-sm">Player3</p>
            </div>

            <p className="text-xs text-muted">+2 more</p>
          </div>

          {/* ACTIONS */}
          <div className="flex flex-col gap-2">
            <button
              className="
                w-full px-3 py-2 rounded-md font-medium
                bg-[#4FC3F7] text-[#0C0F14]
                hover:bg-[#81D4FA] transition
              "
            >
              View Team Profile
            </button>

            <button
              className="
                w-full px-3 py-2 rounded-md font-medium border border-border
                hover:border-[#4FC3F7] hover:text-[#4FC3F7] transition
              "
            >
              Add to Match Prep
            </button>
          </div>
        </div>

        {/* Duplicate this card dynamically later */}
        <div className="bg-surface border border-border rounded-lg p-5 hover:border-[#4FC3F7] transition">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-full bg-[#1F242C]" />
            <div>
              <p className="font-semibold">Team Name</p>
              <p className="text-xs text-muted">Main Division</p>
            </div>
          </div>

          <p className="text-sm mb-3">
            <span className="text-muted">Avg ELO:</span>{" "}
            <span className="font-semibold text-[#4FC3F7]">2300</span>
          </p>

          <div className="space-y-2 mb-4">
            <p className="text-xs text-muted uppercase">Roster</p>

            <div className="flex items-center gap-2">
              <div className="w-6 h-6 rounded-full bg-[#1F242C]" />
              <p className="text-sm">Player1</p>
            </div>

            <div className="flex items-center gap-2">
              <div className="w-6 h-6 rounded-full bg-[#1F242C]" />
              <p className="text-sm">Player2</p>
            </div>

            <p className="text-xs text-muted">+3 more</p>
          </div>

          {/* BUTTONS ALWAYS AT BOTTOM */}
            <div className="flex flex-col gap-2 mt-4">
                <button
                className="
                    w-full px-3 py-2 rounded-md font-medium
                    bg-[#4FC3F7] text-[#0C0F14]
                    hover:bg-[#81D4FA] transition
                "
                >
                View Team Profile
                </button>

                <button
                className="
                    w-full px-3 py-2 rounded-md font-medium border border-border
                    hover:border-[#4FC3F7] hover:text-[#4FC3F7] transition
                "
                >
                Add to Match Prep
                </button>
            </div>
        </div>

      </div>
    </div>
  );
}